module.exports = __webpack_public_path__ + "img/cxample_10.60c84756.png";